
export const SubmissionHeader = () => {
  return (
    <section className="w-full h-[152px] bg-gradient-to-r from-[#ECFDF5] to-white">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-[#111827]">Submission Form</h1>
        <p className="mt-2 text-lg text-gray-600">
          In order to get a bespoke energy report fill out the submission form below.
        </p>
      </div>
    </section>
  );
};
